import { Skeleton } from "components/ui/skeleton";

/* ─── Single skeleton row — matches TrashRow (3 cols) ─────────── */
export function TrashRowSkeleton() {
  return (
    <tr className="border-b border-line-subtle dark:border-dark-700 animate-pulse">
      {/* Col 1: Thumbnail */}
      <td className="pl-5 pr-3 py-3.5 w-px">
        <Skeleton className="w-[72px] h-[48px] rounded-xl" />
      </td>

      {/* Col 2: Name + tag pill + description line */}
      <td className="px-3 py-3.5">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3.5 w-44 rounded-md" />
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-2.5 w-64 rounded" />
        </div>
      </td>

      {/* Col 3: Action buttons */}
      <td className="pr-5 pl-3 py-3.5 w-px">
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-20 rounded-xl" />
          <Skeleton className="h-8 w-[72px] rounded-xl" />
        </div>
      </td>
    </tr>
  );
}

/* ─── Full skeleton card — mirrors actual Trash card ──────────── */
export function TrashListSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div
      className="rounded-2xl overflow-hidden border border-line dark:border-dark-700
        bg-surface dark:bg-dark-800 shadow-sm"
      aria-label="Loading trash items"
    >
      {/* Accent bar */}
      <div className="h-[2px] bg-gradient-to-r from-rose-300 via-pink-300 to-rose-300
        dark:from-rose-800/60 dark:via-pink-800/60 dark:to-rose-800/60" />

      {/* Card header skeleton */}
      <div className="flex items-center justify-between px-5 py-3.5 border-b border-line-subtle dark:border-dark-700 animate-pulse">
        <div className="flex items-center gap-2.5">
          <Skeleton className="w-8 h-8 rounded-lg shrink-0" />
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-3.5 w-36 rounded-md" />
            <Skeleton className="h-2.5 w-52 rounded" />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-7 w-20 rounded-lg" />
          <Skeleton className="h-7 w-16 rounded-lg" />
        </div>
      </div>

      {/* Column header row */}
      <div className="grid grid-cols-[auto_1fr_auto] items-center gap-3 px-5 py-2.5
        bg-gray-50/60 dark:bg-dark-700/30 border-b border-line-subtle dark:border-dark-700 animate-pulse">
        <div className="w-[72px]" />
        <Skeleton className="h-2 w-16 rounded" />
        <Skeleton className="h-2 w-12 rounded" />
      </div>

      {/* Rows */}
      <table className="w-full border-collapse">
        <tbody className="divide-y divide-gray-100 dark:divide-dark-700">
          {Array.from({ length: count }).map((_, i) => (
            <TrashRowSkeleton key={i} />
          ))}
        </tbody>
      </table>
    </div>
  );
}